import Character from './index'

export default class CharacterBuilder {
  constructor (rulebook) {
    this.rulebook = rulebook
  }

  playbookOptions () {
    return this.rulebook.playbooks.map(playbook => playbook.name)
  }

  start (playbookName) {
    this.playbook = this.rulebook.playbooks.find(playbook => playbook.name === playbookName)
    if (this.playbook) {
      this.character = new Character(this.playbook)
      this._setChoice(0)
    }
  }

  choose (value) {
    this.character.choices[this.choice.name] = value
    this._setChoice(this.choiceIndex + 1)
  }

  hasNexChoice () {
    return this.playbook.rules.choices.length > this.choiceIndex + 1
  }

  async finish (ui={}) {
    await this.character.initialize(ui)
  }

  clear () {
    this.playbook = undefined
    this.character = undefined
    this.choiceIndex = undefined
    this.choice = undefined
  }

  _setChoice(index) {
    this.choiceIndex = index
    this.choice = this.playbook.rules.choices[this.choiceIndex]
  }
}
